var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcNoList = function SvgIcNoList(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 132 132",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ic_no_list_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M66.005 132.011c36.454 0 66.006-29.552 66.006-66.006C132.011 29.552 102.459 0 66.005 0 29.552 0 0 29.552 0 66.005c0 36.454 29.552 66.006 66.005 66.006Z",
    fill: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.65 44.902c0-4.363-3.549-7.912-7.911-7.912H42.27c-4.363 0-7.912 3.55-7.912 7.912v42.197c0 4.362 3.55 7.911 7.912 7.911h47.468c4.362 0 7.911-3.549 7.911-7.911V44.902Zm-5.27 42.186a2.642 2.642 0 0 1-2.641 2.641H42.27a2.642 2.642 0 0 1-2.64-2.64V50.171h52.738v36.916h.01Z",
    fill: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m70.103 69.682 4.901-4.901a2.913 2.913 0 0 0 0-4.11 2.913 2.913 0 0 0-4.109 0l-4.9 4.902-4.902-4.901a2.913 2.913 0 0 0-4.109 0 2.913 2.913 0 0 0 0 4.109l4.901 4.9-4.9 4.902a2.913 2.913 0 0 0 0 4.109c.57.57 1.31.855 2.048.855.74 0 1.49-.285 2.05-.855l4.9-4.901 4.902 4.9c.57.57 1.31.856 2.049.856.74 0 1.49-.285 2.049-.855a2.913 2.913 0 0 0 0-4.11l-4.901-4.9h.021Z",
    fill: "#E2E2E2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "ic_no_list_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h132v132H0z"
  })))));
};
export default SvgIcNoList;